<script setup lang="ts">
/**
 * Allow the users to upload UVV documents for a specific machinery.
 * It shouldn't update lastUVVDate as this is deprecated.
 */
import type { ApiMachineryUpdateMachineryUVVDocuments } from '~/types'

const props = defineProps<{
  machinery: ApiMachineryUpdateMachineryUVVDocuments
}>()
const emit = defineEmits<{
  (e: 'update', payload: ApiMachineryUpdateMachineryUVVDocuments): void
  (e: 'close'): void
}>()

const payload = ref<ApiMachineryUpdateMachineryUVVDocuments>({
  id: props.machinery.id,
  documentUVVFiles: props.machinery.documentUVVFiles,
})
</script>

<template>
  <ThePopup show :title="$t('machinery.popup.documentUVVFiles.upload.title', { id: props.machinery.id })" @close="emit('close')">
    <FormKit
      type="form"
      :value="payload"
      :submit-label="$t('button.save')"
      @submit="emit('update', $event)"
    >
      <FormKitFileDropzone name="documentUVVFiles" :label="$t('common.field.documents.name')" />
    </FormKit>
  </ThePopup>
</template>
